export default {
      id: "close-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#close",
      toString: function () {
        return this.url;
      }
    }